import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import { Link, useParams } from 'react-router-dom'

import AnalysisChainForm from './AnalysisChainForm'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useAnalysisChainForm } from './useAnalysisChainForm'

const CreateAnalysisChainPage = () => {
  const { uuid } = useParams()
  const {
    loading,
    saving,
    errors,
    analysisChain,
    analyses,
    dataTypes,
    newParameter,
    hasAvailableSubsequentAnalyses,
    handleInputChange,
    handleAnalysisChange,
    handleDataTypeChange,
    handleAddAnalysis,
    handleRemoveAnalysis,
    handleParameterChange,
    handleRemoveParameter,
    handleAddParameter,
    handleNewParameterChange,
    handleSubmit,
  } = useAnalysisChainForm({ uuid })

  if (loading) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
        <IconButton component={Link} to="/analysis-chains" edge="start">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" component="h1">
          Add Analysis Chain
        </Typography>
      </Stack>

      <AnalysisChainForm
        analysisChain={analysisChain}
        onInputChange={handleInputChange}
        analyses={analyses}
        dataTypes={dataTypes}
        onAnalysisChange={handleAnalysisChange}
        onDataTypeChange={handleDataTypeChange}
        onAddAnalysis={handleAddAnalysis}
        onRemoveAnalysis={handleRemoveAnalysis}
        onParameterChange={handleParameterChange}
        onRemoveParameter={handleRemoveParameter}
        onAddParameter={handleAddParameter}
        onNewParameterChange={handleNewParameterChange}
        newParameter={newParameter}
        hasAvailableSubsequentAnalyses={hasAvailableSubsequentAnalyses}
        onSubmit={handleSubmit}
        saving={saving}
        errors={errors}
        isEditMode={false}
      />
    </Box>
  )
}

export default CreateAnalysisChainPage
